const handleApiError = async (response) => {
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('currentUser');
      window.location.reload();
      throw new Error('Oturum süresi doldu veya yetkiniz yok.');
    }
    const errorData = await response.json();
    throw new Error(errorData.message || 'Hata oluştu');
  }
};

export const fetchBlocks = async (buildingId) => {
  const url = buildingId ? `${process.env.REACT_APP_API_BASE_URL}/api/blocks?buildingId=${buildingId}` : `${process.env.REACT_APP_API_BASE_URL}/api/blocks`;
  const response = await fetch(url, {
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
  });
  await handleApiError(response);
  return response.json();
};

export const addBlock = async (blockData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/blocks`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(blockData),
  });
  await handleApiError(response);
  return response.json();
};

export const updateBlock = async (blockId, blockData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/blocks/${blockId}`, {
    method: 'PUT',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(blockData),
  });
  await handleApiError(response);
  return response.json();
};

export const deleteBlock = async (blockId) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/blocks/${blockId}`, {
    method: 'DELETE',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
  });
  await handleApiError(response);
};
